// @flow
import React from 'react';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Button, Grid, Typography, makeStyles} from '@material-ui/core';
import {Link} from 'react-router-dom';

import previewImage from '../../../../assets/img/custom-domain.png';

type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles(theme => ({
  modalPreview: {
    '& .MuiPaper-root': {
      background: '#18003D',
    },
  },
  preview: {
    maxWidth: 700,
    // maxHeight: 750,
    padding: theme.spacing(7, 4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: 'white',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: 'white',
    margin: theme.spacing(2, 0),
    textAlign: 'center',
  },
  img: {
    width: '100%',
    height: '100%',
    display: 'block',
    margin: '0 auto',
  },
  buttonPro: {
    padding: theme.spacing(1, 4),
    background: 'linear-gradient(to right, #FFC83B, #7B39FF)',
    color: 'white',
    textTransform: 'none',
    borderRadius: 20,
  },
  buttonWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default function DisabledTierModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();
  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.modalPreview}
    >
      <div className={classes.preview}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <img
              src={previewImage}
              alt="custom domain"
              className={classes.img}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.title} gutterBottom>
              ¡Actualiza tu plan!
            </Typography>
            <Typography className={classes.subtitle}>
              Actualiza tu plan para tener más
              <br /> control de tu personalización.
            </Typography>
            <div className={classes.buttonWrap}>
              <Button
                className={classes.buttonPro}
                component={Link}
                to="/tiers-list"
              >
                Mejorar plan
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </CustomModal>
  );
}
